import { $myFetch } from ".";

export const $getTranslations = () => {
  const myHeaders = new Headers()
  return $myFetch(
    "translations",
    {
      headers: myHeaders
    }
  )
} 